import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function InProgress({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-7 -3.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M23.0543333 28.166c.0373334-4.8233333-2.76-9.3053333-7.136-10.802C10.577 15.5373333 4.91033333 18.8513333 3.261 24.766c-.316 1.132-.46133333 2.276-.45266667 3.4h-.00066666v3.9786667H23.0563333V28.166h-.002z" />
        <path d="M23.0543333 5.49413333c.0373334 4.82333334-2.76 9.30599997-7.136 10.80266667C10.577 18.1228 4.91033333 14.8088 3.261 8.89413333c-.316-1.13133333-.46133333-2.276-.45266667-3.4h-.00066666V1.51546667H23.0563333v3.97866666h-.002zM19.9261333 5.50193333c.034 3.342-1.8986666 6.45133337-4.93 7.48799997M.37273333 1.49673333H25.4920667M.37273333 32.1634H25.4920667M3.3978 24.6884667h18.938" />
      </g>
    </svg>
  )
}

InProgress.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
